import cx from 'classnames';

import styles from './LinkItem.module.scss';

export type LinkItemProps = {
	className?: string;
	label: string;
	onClick: () => void;
	onHover?: () => void;
};

export const LinkItem: React.FC<LinkItemProps> = ({ className, label, onClick, onHover }) => {
	return (
		<button className={cx([className, styles.link])} onClick={onClick} onMouseEnter={onHover}>
			{label}
		</button>
	);
};
